import type { GlobalStyles } from '@mui/system';
import type { ComponentProps } from 'react';

export const globalStyling: ComponentProps<typeof GlobalStyles>['styles'] = {
  body: {
    minHeight: '100vh',
  },
  '*::-webkit-scrollbar': {
    width: '0.5em',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
    width: '0.1em',
  },
  '*::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
  tr: {
    '&:last-child': {
      td: {
        borderBottom: 'none !important;',
      },
    },
  },
  '.notistack-SnackbarContainer': {
    zIndex: 2147483647,
  },
};
